import { useMemo } from "react"

export const useFilteredGuestSuggestions = suggestions => {
  return useMemo(() => {
    return suggestions.filter(
      ({ isCreated, isPublished }) => !isCreated || isPublished
    )
  }, [suggestions])
}
